import { BASE_URL } from "./config";

export async function fetchListings() {
    const res = await fetch(`${BASE_URL}/listings`);
    return res.json();
}

export async function fetchListing(id) {
    const res = await fetch(`${BASE_URL}/listings/${id}`);
    return res.json();
}

export async function createListing(data) {
    const res = await fetch(`${BASE_URL}/listings`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    return res.json();
}